import styled from "styled-components";

import { SPACING } from "../../utils/constants";
import { BaseButton } from "../Button";

export const DisclosureToggle = styled(BaseButton)`
  background: none;
  border: none;
  padding: 0;
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--color-primary);
  cursor: pointer;
  text-decoration: underline;

  &:disabled {
    color: var(--color-text-muted);
    opacity: 1;
  }
`;

export const DisclosurePanel = styled.div`
  gap: ${SPACING.sm}px;
  padding: ${SPACING.sm}px;
  border: 1px dashed var(--color-border);
  border-radius: 12px;
  background: var(--color-background-2);
`;
